import { AppThunkAction } from '../store';
import { ActionTypes as NotificationsStoreActionTypes, AddNotificationAction } from './NotificationsStore';
import { FetchConfig } from './middlewares/FetchMiddleware';
import { ArchiveItem, ArchiveItemDTO } from '../api/client';
import { Reducer } from 'redux';

export enum ActionTypes {
    REGISTER_ARCHIVE_ITEM = '@@archive/REGISTER_ARCHIVE_ITEM',
    REGISTER_ARCHIVE_ITEM_REQUEST = '@@archive/REGISTER_ARCHIVE_ITEM_REQUEST',
    REGISTER_ARCHIVE_ITEM_SUCCESS = '@@archive/REGISTER_ARCHIVE_ITEM_SUCCESS',
    REGISTER_ARCHIVE_ITEM_FAILURE = '@@archive/REGISTER_ARCHIVE_ITEM_FAILURE',
    GET_ARCHIVE_ITEM_BY_ID = '@@archive/GET_ARCHIVE_ITEM_BY_ID',
    GET_ARCHIVE_ITEM_BY_ID_REQUEST = '@@archive/GET_ARCHIVE_ITEM_BY_ID_REQUEST',
    GET_ARCHIVE_ITEM_BY_ID_SUCCESS = '@@archive/GET_ARCHIVE_ITEM_BY_ID_SUCCESS',
    GET_ARCHIVE_ITEM_BY_ID_FAILURE = '@@archive/GET_ARCHIVE_ITEM_BY_ID_FAILURE',
    CLEAR_ARCHIVE_ITEM = '@@archive/CLEAR_ARCHIVE_ITEM',
    CLEAR_ARCHIVE_ID = '@@archive/CLEAR_ARCHIVE_ID',
}

export interface ArchiveState {
  archiveId: number | null;
  isLoadingArchiveId: boolean;
  archiveItem: ArchiveItem | null;
  isLoadingArchiveItem: boolean;
}

interface RegisterArchiveItemAction { type: ActionTypes.REGISTER_ARCHIVE_ITEM; fetchConfig: FetchConfig; }
interface RegisterArchiveItemRequestAction { type: ActionTypes.REGISTER_ARCHIVE_ITEM_REQUEST; }
interface RegisterArchiveItemSuccessAction { type: ActionTypes.REGISTER_ARCHIVE_ITEM_SUCCESS; archiveId: number;}
interface RegisterArchiveItemFailureAction { type: ActionTypes.REGISTER_ARCHIVE_ITEM_FAILURE; }

interface GetArchiveItemByIdAction { type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID; fetchConfig: FetchConfig; }
interface GetArchiveItemByIdRequestAction { type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID_REQUEST;}
interface GetArchiveItemByIdSuccessAction { type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID_SUCCESS; response: ArchiveItem }
interface GetArchiveItemByIdFailureAction { type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID_FAILURE;}

interface ClearArchiveId { type: ActionTypes.CLEAR_ARCHIVE_ID; }
interface ClearArchiveItem { type: ActionTypes.CLEAR_ARCHIVE_ITEM; }

export type KnownAction = AddNotificationAction
    | RegisterArchiveItemAction
    | RegisterArchiveItemRequestAction
    | RegisterArchiveItemSuccessAction
    | RegisterArchiveItemFailureAction
    | GetArchiveItemByIdAction
    | GetArchiveItemByIdRequestAction
    | GetArchiveItemByIdSuccessAction
    | GetArchiveItemByIdFailureAction
    | ClearArchiveItem
    | ClearArchiveId;

export const actionCreators = {
  registerArchiveItem: (archiveItemDTO: ArchiveItemDTO): AppThunkAction<KnownAction> => (dispatch) => {
    return dispatch({
      type: ActionTypes.REGISTER_ARCHIVE_ITEM,
      fetchConfig: {
        init: { type: ActionTypes.REGISTER_ARCHIVE_ITEM_REQUEST },
        path: `/api/archive`,
        method: 'POST',
        body: archiveItemDTO,
        signal: undefined,
        success: (json) => {
          dispatch({ type: ActionTypes.REGISTER_ARCHIVE_ITEM_SUCCESS, archiveId: json });
        },
        failure: (error: string) => {
          dispatch({ type: ActionTypes.REGISTER_ARCHIVE_ITEM_FAILURE });
          dispatch({ type: NotificationsStoreActionTypes.ADD_NOTIFICATION, notification: { message: 'Kunne ikke registrere fil', variant: 'error' } });
        }
      }
    });
  },
  getArchiveItemById: (archiveId: number): AppThunkAction<KnownAction> => dispatch => {
    return dispatch({
      type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID,
      fetchConfig: {
        init: { type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID_REQUEST },
        method: 'GET',
        path: `/api/archive/${archiveId}`,
        signal: undefined,
        success: (json) => {
          dispatch({ 
            type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID_SUCCESS, 
            response: json
          });
        },
        failure: (error: string) => {
          dispatch({ type: ActionTypes.GET_ARCHIVE_ITEM_BY_ID_FAILURE });
          dispatch({
            type: NotificationsStoreActionTypes.ADD_NOTIFICATION,
            notification: { 
              message: `Kunne ikke hente fil med id ${archiveId}`, 
              variant: 'error' 
            }
          });
        }
      }
    });
  },
  clearArchiveId: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
    return dispatch({ type: ActionTypes.CLEAR_ARCHIVE_ID });
  },
  clearArchiveItem: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
    return dispatch({ type: ActionTypes.CLEAR_ARCHIVE_ITEM });
  },
};

export const initialState: ArchiveState = { archiveId: null, isLoadingArchiveId: false, archiveItem: null, isLoadingArchiveItem: false };

export const reducer: Reducer<ArchiveState | undefined, KnownAction> = (state: ArchiveState = initialState, action: KnownAction) => {
  switch (action.type) {
    case ActionTypes.GET_ARCHIVE_ITEM_BY_ID_REQUEST:
      return { ...state, isLoading: true };
    case ActionTypes.GET_ARCHIVE_ITEM_BY_ID_SUCCESS:
      return { ...state, archiveItem: action.response, isLoading: false };
    case ActionTypes.REGISTER_ARCHIVE_ITEM_REQUEST:
      return { ...state, isLoadingArchiveId: true };
    case ActionTypes.REGISTER_ARCHIVE_ITEM_SUCCESS:
      return { ...state, archiveId: action.archiveId, isLoadingArchiveId: false };
    case ActionTypes.CLEAR_ARCHIVE_ITEM:
      return { ...state, archiveItem: null };
    case ActionTypes.CLEAR_ARCHIVE_ID:
      return { ...state, archiveId: null };
    case ActionTypes.GET_ARCHIVE_ITEM_BY_ID_FAILURE:
        return { ...state, archiveItem: null, isLoadingArchiveItem: false };
    case ActionTypes.REGISTER_ARCHIVE_ITEM_FAILURE:
        return { ...state, archiveId: null, isLoadingArchiveId: false };
    default:
      return state;
  }
};